import React, { Component, useState } from "react";
import Layout from "../../layouts/index";
// import Hero from '../components/hero/Hero';
// import HeroIllustration from '../components/hero/HeroIllustration';
import Grid from "@mui/material/Grid2";
import { Tab, Tabs, Typography, Button, Divider } from "@mui/material";
import { NavLink } from "react-router-dom";
import productTabsData from "../../data/productstab.json";
import carouselData from "../../data/homeCarousel.json";
// import classes from '*.module.css';
import ArrowForward from "@mui/icons-material/ArrowForward";
// import AboutUsSection from "./AboutUsSection";
import BackgroundImageTop from "../../assets/images/shape_crescent-top.png";
import BackgroundImageBottom from "../../assets/images/shape_crescent-bottom.png";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const PREFIX = "RediflyTabSection";

const classes = {
  productTabLabel: `${PREFIX}-productTabLabel`,
  productTabSelected: `${PREFIX}-productTabSelected`,
  backgroundDesign2: `${PREFIX}-backgroundDesign2`,
  exploreProductLink: `${PREFIX}-exploreProductLink`,
  tabContainerBlock: `${PREFIX}-tabContainerBlock`,
  buttonContainer: `${PREFIX}-buttonContainer`,
  productTabsContainer: `${PREFIX}-productTabsContainer`,
  productTabsDesc: `${PREFIX}-productTabsDesc`,
  tabContainerTabs: `${PREFIX}-tabContainerTabs`,
  productImage: `${PREFIX}-productImage`,
  productImageCoreCommand: `${PREFIX}-productImageCoreCommand`,
  productImageOtherThanCoreCommand: `${PREFIX}-productImageOtherThanCoreCommand`,
  exploreAnchorLink: `${PREFIX}-exploreAnchorLink`,
  root: `${PREFIX}-root`,
  heading: `${PREFIX}-heading`,
  bookDemoButton: `${PREFIX}-bookDemoButton`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.root}`]: {
    "& .MuiGrid2-root": {
      padding: "0 24px 0 40px",
    },
  },
  [`& .${classes.productTabsContainer}`]: {
    padding: "0 24px 0 40px",
    [theme.breakpoints.down("sm")]: {
      padding: 0,
    },
  },
  [`& .${classes.backgroundDesign2}`]: {
    // background: `transparent url(${BackgroundImageBottom}) -20% 111% no-repeat padding-box`,
    backgroundColor: "#fefbfb",
  },
  [`& .${classes.tabContainerTabs}`]: {
    marginLeft: "0.5em",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  [`& .${classes.productTabLabel}`]: {
    textTransform: "capitalize",
    fontSize: 25,
    fontFamily: "AvenirLTStd-Roman",
    alignItems: "flex-start",
    // transition: "width .3s",
    [theme.breakpoints.down("sm")]: {
      paddingRight: "1em",
      fontSize: 20,
    },
    [theme.breakpoints.between("sm", "md")]: {
      // background: '#ff000026'
      fontSize: 25,
    },
    [theme.breakpoints.between("md", "lg")]: {
      // background: 'green'
      fontSize: 28,
    },
  },
  [`& .${classes.productTabSelected}`]: {
    color: "#000 !important",
  },
  [`& .${classes.tabContainerBlock}`]: {
    padding: "3em 24px 24px 24px",
    [theme.breakpoints.down("sm")]: {
      padding: "0 0 1em 0 !important",
    },
    [theme.breakpoints.between("sm", "md")]: {
      // background: '#ff000026'
      fontSize: 30,
    },
    [theme.breakpoints.between("md", "lg")]: {
      // background: 'green'
      fontSize: 35,
    },
  },
  [`& .${classes.productImage}`]: {
    minHeight: 200,
    minWidth: 200,
    maxWidth: "initial",
    // height: 600,
    // width: 600
    [theme.breakpoints.down("sm")]: {
      width: 500,
      height: "auto",
      marginTop: "1em",
    },
  },
  [`& .${classes.productImageCoreCommand}`]: {
    height: 500,
    width: 700,
    [theme.breakpoints.down("sm")]: {
      width: 390, // width: 500,
      height: "auto",
      maxWidth: "inherit",
      marginTop: "1em",
    },
    [theme.breakpoints.between("sm", "lg")]: {
      width: 400,
      height: 300,
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: "initial",
    },
  },
  [`& .${classes.productImageOtherThanCoreCommand}`]: {
    height: 500,
    width: 600,
    [theme.breakpoints.down("sm")]: {
      width: 390, //width: 500,
      height: "auto",
      maxWidth: "inherit",
      marginTop: "1em",
    },
    [theme.breakpoints.between("sm", "lg")]: {
      width: 360,
      height: 400,
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: "initial",
    },
  },
  [`& .${classes.productTabsDesc}`]: {
    padding: "1em",
    fontFamily: "AvenirLTStd-Book",
    fontSize: 23, // fontSize: 28,
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 25,
    },
    [theme.breakpoints.between("md", "lg")]: {
      fontSize: 25,
    },
  },
  [`& .${classes.exploreProductLink}`]: {
    textAlign: "left",
    padding: "1em 1em 1em 1.5em",
    [theme.breakpoints.down("sm")]: {
      padding: "0 1em",
    },
  },
  [`& .${classes.exploreAnchorLink}`]: {
    textDecoration: "none",
    color: "#B41E1C",
    fontFamily: " AvenirLTStd-Roman",
    fontSize: 26, //fontSize: '30px',
    fontWeight: 700,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.2rem",
    },
    "@media (min-width: 375px)": {
      fontSize: 18,
    },
    "@media (min-width: 800px)": {
      fontSize: 26,
    },
    "@media (min-width: 1280px)": {
      fontSize: 30,
    },
  },
  [`& .${classes.heading}`]: {
    fontSize: 32,
    fontWeight: "bold",
    marginBottom: "20px",
    paddingLeft: "1em",
    paddingTop: "1em",
    fontFamily: " AvenirLTStd-Roman",
    [theme.breakpoints.down("sm")]: {
      fontSize: 24,
      paddingTop: "1em",
      paddingLeft: "1em",
    },
  },
  [`& .${classes.bookDemoButton}`]: {
    background: "#B41E1C",
    color: "#fff",
    textTransform: "capitalize",
    fontFamily: "AvenirLTStd-Roman",
    marginTop: "2em",
    padding: "0.5rem",
    fontWeight: "none",
    borderRadius: "24px",
    fontSize: 15,
    width: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem",
      marginLeft: 0,
    },
  },
}));

const RediflyTabSection = () => {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();

  const handleChange = (event, value) => {
    setValue(value);
  };

  return (
    <StyledGrid container>
      <Grid size={{ xs: 12 }}>
        <Typography variant="h4" className={classes.heading}>
          The REDiFly eTechlog
        </Typography>
      </Grid>

      <Grid
        size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        className={[classes.productTabsContainer, classes.productTabsDesc].join(
          " "
        )}
        // sx={{     padding: "0 24px 0 40px",     backgroundColor: "#fefbfb",

        // }}
        // data-aos="fade-up"
        // data-aos-anchor-placement="top-bottom"
      >
        <Tabs
          value={value}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          variant="scrollable"
          classes={{ indicator: "product-tabs-indicator" }}
          className={classes.tabContainerTabs}
        >
          {productTabsData &&
            productTabsData.map((item, index) => {
              return (
                <Tab
                  key={index}
                  // classes={[
                  //   {
                  //     // wrapper: classes.productTabLabel,
                  //     selected: classes.productTabSelected,
                  //   },
                  //   classes.productTabLabel,
                  // ].join("")}
                  //label={item.name}
                  label={
                    <span className={classes.productTabLabel}>{item.name}</span>
                  }
                  //className={["cool-link", classes.productTabLabel].join("")}
                  sx={{
                    "&.Mui-selected": {
                      color: "#000",
                      textTransform: "capitalize",
                      textAlign: "start",
                      alignItems: "flex-start",
                      padding: "12px 8px",
                      fontSize: 25,
                    },
                  }}
                  // sx={{ "& .MuiButtonBase-root-MuiTab-root.Mui-selected":  { color: "#000"}}}
                />
              );
            })}
        </Tabs>

        {productTabsData &&
          productTabsData.map((item, index) => {
            return (
              value === index && (
                <Typography
                  component="div"
                  key={index}
                  className={classes.tabContainerBlock}
                  style={{ padding: "3em 24px 24px 24px" }}
                >
                  {" "}
                  <Grid container className="product-tab-container">
                    <Grid
                      size={{ xs: 12, sm: 6, md: 6, lg: 6 }}
                      sx={
                        {
                          // display: "flex",
                          // justifiyContent: "center",
                          // alignItems: "center",
                        }
                      }
                    >
                      <img
                        alt="product"
                        className={[
                          classes.productImage,
                          item.id === "core" || item.id === "command"
                            ? classes.productImageCoreCommand
                            : classes.productImageOtherThanCoreCommand,
                        ].join(" ")}
                        src={item.imagePath}
                      />
                    </Grid>
                    <Grid
                      size={{ xs: 12, sm: 6, md: 6, lg: 6 }}
                      // style={{
                      //   display: "flex",
                      //   alignSelf: "center",
                      //   flexDirection: "column",
                      // }}
                    >
                      <span className="product-content-border-top" />
                      <Typography
                        variant="body1"
                        className={classes.productTabsDesc}
                      >
                        {item.description}
                      </Typography>
                      <Grid
                        size={{ xs: 6 }}
                        className={classes.exploreProductLink}
                      >
                        {/* <NavLink
                          to={item.redirectPath}
                          className={classes.exploreAnchorLink}
                        >
                          <span>
                            Explore REDiFly {item.name}{" "}
                            <ArrowForward
                              className={classes.arrow}
                              sx={{ position: "relative", top: 0 }}
                            />
                          </span>
                        </NavLink> */}
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.bookDemoButton}
                          endIcon={<ArrowForward />}
                          onClick={() => {
                            navigate("/etl");
                            window.scrollTo(0, 0);
                          }}
                        >
                          Explore REDiFly {item.name}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Typography>
              )
            );
          })}
      </Grid>
    </StyledGrid>
  );
};
export default RediflyTabSection;
